'use strict';
var slickConfigs = require('org/config/slickConfigs');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($('.email-signup-message').length === 0) {
        $('body').append(
           '<div class="email-signup-message"></div>'
        );
    }
    $('.email-signup-message')
        .append('<div class="email-signup-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.email-signup-message').remove();
        button.removeAttr('disabled');
    }, 3000);
}

function isEmail(email) { //eslint-disable-line
    var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/; //eslint-disable-line
    if (!regex.test(email)) {
        return false;
    }
}

var startInactivityTime = Date.now();

/**
 * Inactivity timer to Show session timeout popup message
 */
function inactivityTimer() {
    var endInactivityTime = Date.now();
    if (endInactivityTime - startInactivityTime >= (30 * 60 * 1000)) {
        $('#sessionInactivityModal').modal('show');
        startInactivityTime = Date.now();
    } else {
        startInactivityTime = endInactivityTime;
    }
}

/**
 * Marks a Klaviyo popup form as private so LogRocket does not replay input values.
 * Footer/store embeds are skipped because they already sit inside [data-private].
 * @param {string} formId - Klaviyo form id from the klaviyoForms event
 */
function markKlaviyoPopupPrivate(formId) {
    var form = null;

    if (formId) {
        form = document.querySelector('[data-testid="klaviyo-form-' + formId + '"]');
    }
    if (!form) {
        form = document.querySelector('form.klaviyo-form:not([data-private])');
    }
    if (!form || form.closest('[data-private]')) {
        return;
    }

    form.setAttribute('data-private', '');

    var fields = form.querySelectorAll('input, select, textarea');
    for (var i = 0; i < fields.length; i++) {
        fields[i].setAttribute('data-private', '');
    }
}

/**
 * Listens for Klaviyo onsite popup open events and applies LogRocket data-private.
 */
function initKlaviyoPopupPrivacy() {
    window.addEventListener('klaviyoForms', function (e) {
        if (!e.detail || e.detail.type !== 'open') {
            return;
        }
        window.setTimeout(function () {
            markKlaviyoPopupPrivate(e.detail.formId);
        }, 100);
    });
}

module.exports = function () {
    initKlaviyoPopupPrivacy();

    // back-to-top code enhanced, moved to backtotop.js

    $('form.footer-email-signup').has('.subscribe-email').on('submit', function (e) {
        e.preventDefault();
        var $form = $(this);
        var button = $form.find('.subscribe-email');
        var $emailField = $form.find('input[name=hpEmailSignUp]');
        var url = button.data('href');
        var emailId = $emailField.val();
        if ($emailField.get(0).checkValidity && !$emailField.get(0).checkValidity()) {
            $emailField.trigger('invalid', $emailField.get(0).validity).focus();
            return;
        }

        $.spinner().start();
        button.attr('disabled', true);
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                emailId: emailId
            },
            success: function (data) {
                displayMessage(data, button, $form);
            },
            error: function (err) {
                displayMessage(err, button, $form);
            }
        });
    });

    // CHEF Email Sign-Up
    var successFormText;
    var emailField = $('#email-SignUp-Footer');
    var emailPlaceholderText = $('.footer-signup #email-SignUp-Footer').attr('placeholder');
    var subscribeSMSFormWrapper = $('.footer-signup');

    function resetSubscribeForm() { //eslint-disable-line
        subscribeSMSFormWrapper.removeClass('subscribeSignupSuccess subscribeSignupError');
        emailField.attr('placeholder', emailPlaceholderText);
        emailField.val();
        $('.subscribe-email-chef').removeClass('d-none');
        $('.subscribe-email-chef-success').addClass('d-none');
    }

    $('.footer-email-chef #email-SignUp-Footer').on('focus', function () {
        resetSubscribeForm();
    });

    $('.footer-email-chef').submit(function (e) {
        e.preventDefault();

        var $form = $(this);
        var url = $form.attr('action');
        var emailValue = emailField.val();
        var formData = $form.serialize();

        successFormText = emailField.data('success-message');
        $('#footer-email-signup-status').text('');

        if (!subscribeSMSFormWrapper.hasClass('subscribeSignupSuccess')) {
            if (isEmail(emailValue) === false || emailValue === '' || emailValue === emailPlaceholderText) {
                subscribeSMSFormWrapper.removeClass('subscribeSignupSuccess');
                subscribeSMSFormWrapper.addClass('subscribeSignupError');
                emailField.attr('placeholder', emailPlaceholderText);
            } else {
                $.ajax({
                    url: url,
                    type: 'POST',
                    crossDomain: true,
                    data: formData,
                    dataType: 'jsonp'
                }).always(function () {
                    emailField.val('');
                    emailField.attr('placeholder', successFormText);
                    subscribeSMSFormWrapper.removeClass('subscribeSignupError');
                    subscribeSMSFormWrapper.addClass('subscribeSignupSuccess');
                    $('.subscribe-email-chef').addClass('d-none');
                    $('.subscribe-email-chef-success').removeClass('d-none').focus();
                    $('#footer-email-signup-status').text(successFormText);
                });
            }
        } else {
            resetSubscribeForm();
        }
    });

    $('.footer-carousel').slick(slickConfigs.footerBanner);

    // SMS form
    $('form.footer-sms-optin').on('submit', function (e) {
        e.preventDefault();
        var $form = $(this);
        var $smsPhoneField = $('#phone-SignUp-Footer');
        $('#footer-sms-signup-status').text('');

        if (!!$smsPhoneField.val() && $smsPhoneField.get(0).validity.valid) {
            $form.spinner().start();
            setTimeout(function () {
                var successMessage = $smsPhoneField.data('success-message');
                $smsPhoneField.trigger('blur').val('').get(0).placeholder = successMessage;
                $('#footer-sms-signup-status').text(successMessage);
                $.spinner().stop();
            }, 1000);
        } else {
            $smsPhoneField.trigger('invalid', $smsPhoneField.get(0).validity).focus();
        }
    });

    $('#phone-SignUp-Footer').on('focus', function () {
        var $this = $(this);
        $this.get(0).placeholder = $this.data('placeholder');
    });

    // International Checkout Info Modal
    if ($('#international-checkout-info')) {
        $('#international-checkout-info').modal('show');
    }

    // Show Session Inactivity Modal
    if ($('#sessionInactivityModal').length) {
        $('#sessionInactivityModal').on('hidden.bs.modal', function () {
            $(this).data('bs.modal', null).remove();
            location.reload();
        });

        window.addEventListener('load', inactivityTimer, true);
        var events = ['mousemove', 'mousedown', 'keydown', 'click', 'touchstart', 'scroll'];
        events.forEach(function (event) {
            document.addEventListener(event, inactivityTimer, true);
        });
    }
};
